import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/contexts/auth.context';
import { useAlertContext } from '@/contexts/alert.context';

export type LoginFormData = {
  email: string;
  password: string;
};

export function useLogin() {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const { notify } = useAlertContext();

  const onSubmit = async ({ email, password }: LoginFormData) => {
    setLoading(true);
    try {
      await login(email, password);
      // Navigation is handled by AppRoutes automatically
    } catch (error: any) {
      const errorMessage = error?.message || 'E-mail ou senha incorretos';
      notify({
        type: 'error',
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  const forgotPassword = () => {
    navigation('/recover-password');
  };

  return {
    onSubmit,
    forgotPassword,
    loading,
  };
}
